module.exports = __webpack_public_path__ + "img/jiraya-3.0cb2a657.jpg";